export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'allchinabuy-spreadsheet-complete-guide',
    title: 'The Complete AllChinaBuy Spreadsheet Guide for 2025',
    excerpt: 'Discover how to navigate the AllChinaBuy spreadsheet efficiently. Learn product categories, seller verification methods, quality control tips, and shipping strategies to maximize your shopping experience.',
    category: 'Guides',
    date: '2025-08-15',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20organized%20desk%20scene%20with%20an%20open%20laptop%20showing%20a%20colorful%20spreadsheet%20of%20fashion%20products%2C%20a%20ceramic%20coffee%20cup%20and%20notebook%20beside%20it%2C%20warm%20natural%20window%20light%2C%20fresh%20productivity%20editorial%20photography%20with%20cream%20and%20warm%20beige%20tones%2C%20clean%20airy%20composition&width=800&height=500&seq=article-1&orientation=landscape',
  },
  {
    id: '2',
    slug: 'allchinabuy-shipping-cost-guide',
    title: 'AllChinaBuy Shipping Cost Guide: Save Money on International Delivery',
    excerpt: 'Compare shipping methods, calculate costs, and discover the best delivery options for your country. Everything you need to know about AllChinaBuy shipping in one comprehensive guide.',
    category: 'Shipping',
    date: '2025-08-10',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20brown%20kraft%20shipping%20boxes%20with%20a%20small%20package%20scale%20and%20measuring%20tape%20beside%20them%20on%20a%20light%20wooden%20surface%2C%20soft%20natural%20studio%20lighting%2C%20clean%20logistics%20editorial%20photography%20with%20warm%20cardboard%20and%20cream%20tones%2C%20tidy%20minimal%20composition&width=800&height=500&seq=article-2&orientation=landscape',
  },
  {
    id: '3',
    slug: 'allchinabuy-qc-quality-control',
    title: 'AllChinaBuy QC Guide: How to Ensure Product Quality Every Time',
    excerpt: 'Master the art of quality control when buying through AllChinaBuy. Learn inspection tips, photo verification, common defects to watch for, and how to communicate with sellers for the best results.',
    category: 'QC',
    date: '2025-08-05',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20up%20of%20hands%20inspecting%20a%20folded%20premium%20shirt%20with%20a%20magnifying%20glass%20on%20a%20clean%20warm%20white%20desk%2C%20soft%20focused%20lighting%2C%20careful%20quality%20control%20editorial%20photography%20with%20warm%20neutral%20beige%20tones%2C%20sharp%20detailed%20composition&width=800&height=500&seq=article-3&orientation=landscape',
  },
  {
    id: '4',
    slug: 'allchinabuy-review-is-it-legit',
    title: 'AllChinaBuy Review: Is It Legit, Safe & Worth Using in 2025?',
    excerpt: 'An honest, detailed review of AllChinaBuy covering legitimacy, safety, pros and cons, and whether the platform is worth using for your overseas shopping needs.',
    category: 'Review',
    date: '2025-08-20',
    readTime: '9 min',
    image: 'https://readdy.ai/api/search-image?query=A%20glowing%20five%20star%20rating%20card%20with%20a%20small%20shield%20badge%20and%20checkmark%20resting%20on%20a%20soft%20cream%20desk%20surface%2C%20warm%20confident%20lighting%2C%20trust%20and%20reliability%20editorial%20photography%20with%20warm%20amber%20and%20cream%20palette%2C%20clean%20optimistic%20composition&width=800&height=500&seq=article-4&orientation=landscape',
  },
  {
    id: '5',
    slug: 'allchinabuy-coupon-discount-code',
    title: 'AllChinaBuy Coupon & Discount Code Guide: How to Save Money',
    excerpt: 'Find active AllChinaBuy coupon codes, understand how discounts work, and learn proven strategies to lower your total cost on every order.',
    category: 'Coupon',
    date: '2025-08-18',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20yellow%20price%20tag%20with%20a%20percentage%20symbol%20and%20a%20pair%20of%20scissors%20resting%20on%20a%20soft%20cream%20surface%2C%20fresh%20cheerful%20lighting%2C%20savings%20and%20deals%20editorial%20photography%20with%20sunny%20yellow%20and%20cream%20palette%2C%20playful%20clean%20composition&width=800&height=500&seq=article-5&orientation=landscape',
  },
  {
    id: '6',
    slug: 'allchinabuy-warehouse-guide',
    title: 'AllChinaBuy Warehouse Guide: Storage, Consolidation & Shipping',
    excerpt: 'Understand how the AllChinaBuy warehouse works, how items are stored and consolidated, and how to use it to save money on international shipping.',
    category: 'Warehouse',
    date: '2025-08-16',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20warehouse%20shelves%20filled%20with%20small%20labeled%20brown%20boxes%20in%20warm%20soft%20lighting%2C%20orderly%20logistics%20editorial%20photography%20with%20warm%20brown%20and%20cream%20tones%2C%20clean%20structured%20composition%20with%20depth%20and%20clarity&width=800&height=500&seq=article-6&orientation=landscape',
  },
  {
    id: '7',
    slug: 'allchinabuy-seller-guide',
    title: 'AllChinaBuy Seller Guide: How to Find Trusted Sellers',
    excerpt: 'Learn how to identify reliable sellers on AllChinaBuy, read seller signals, check reviews, and reduce your risk when buying from overseas vendors.',
    category: 'Sellers',
    date: '2025-08-14',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20handshake%20between%20two%20business%20partners%20over%20a%20tidy%20wooden%20desk%20with%20a%20small%20storefront%20sign%20in%20the%20background%2C%20soft%20inviting%20lighting%2C%20trust%20and%20partnership%20editorial%20photography%20with%20warm%20beige%20and%20wood%20tones%2C%20clean%20professional%20composition&width=800&height=500&seq=article-7&orientation=landscape',
  },
  {
    id: '8',
    slug: 'allchinabuy-buying-guide',
    title: 'AllChinaBuy Buying Guide: Step-by-Step for Beginners',
    excerpt: 'A clear, beginner-friendly walkthrough of the entire AllChinaBuy buying process, from browsing the spreadsheet to receiving your package at your door.',
    category: 'Guides',
    date: '2025-08-12',
    readTime: '10 min',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20checklist%20with%20checkmarks%20next%20to%20a%20small%20shopping%20cart%20icon%20and%20neatly%20arranged%20product%20cards%20on%20a%20warm%20cream%20desk%2C%20bright%20fresh%20lighting%2C%20step%20by%20step%20guide%20editorial%20photography%20with%20warm%20neutral%20tones%2C%20organized%20inviting%20composition&width=800&height=500&seq=article-8&orientation=landscape',
  },
  {
    id: '9',
    slug: 'allchinabuy-payment-safety',
    title: 'AllChinaBuy Payment Safety: Protect Yourself When Buying',
    excerpt: 'A practical guide to secure payments on AllChinaBuy, including how to protect your card, spot scams, and what to do if something goes wrong.',
    category: 'Safety',
    date: '2025-08-11',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=A%20credit%20card%20beside%20a%20small%20green%20padlock%20and%20shield%20icon%20on%20a%20clean%20warm%20white%20surface%2C%20reassuring%20soft%20lighting%2C%20secure%20payment%20editorial%20photography%20with%20sage%20green%20and%20cream%20palette%2C%20calm%20trustworthy%20composition&width=800&height=500&seq=article-9&orientation=landscape',
  },
  {
    id: '10',
    slug: 'allchinabuy-shipping-to-usa',
    title: 'AllChinaBuy Shipping to USA: Costs, Times & Best Methods',
    excerpt: 'Everything US buyers need to know about AllChinaBuy shipping, including typical costs, delivery timelines, and the best shipping methods for the United States.',
    category: 'Shipping',
    date: '2025-08-09',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20parcel%20box%20with%20a%20tiny%20red%20white%20and%20blue%20ribbon%20flag%20beside%20it%20on%20a%20warm%20cream%20desk%20surface%2C%20soft%20natural%20lighting%2C%20international%20delivery%20to%20America%20editorial%20photography%20with%20warm%20neutral%20and%20subtle%20red%20accents%2C%20clean%20composition&width=800&height=500&seq=article-10&orientation=landscape',
  },
  {
    id: '11',
    slug: 'allchinabuy-shipping-to-uk',
    title: 'AllChinaBuy Shipping to UK: Complete Guide for British Buyers',
    excerpt: 'A dedicated guide to AllChinaBuy shipping for UK shoppers, covering costs, customs, delivery times, and the smartest shipping choices for Britain.',
    category: 'Shipping',
    date: '2025-08-07',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20cardboard%20parcel%20with%20a%20subtle%20union%20jack%20ribbon%20accent%20resting%20on%20a%20warm%20cream%20surface%2C%20soft%20window%20lighting%2C%20international%20delivery%20to%20United%20Kingdom%20editorial%20photography%20with%20warm%20neutral%20and%20muted%20navy%20red%20tones%2C%20clean%20tidy%20composition&width=800&height=500&seq=article-11&orientation=landscape',
  },
  {
    id: '12',
    slug: 'allchinabuy-beginner-mistakes',
    title: 'AllChinaBuy Beginner Mistakes: 10 Errors to Avoid',
    excerpt: 'Avoid the most common and costly mistakes new AllChinaBuy users make, from skipping QC to underestimating shipping, with actionable tips to get it right.',
    category: 'Guides',
    date: '2025-08-04',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20wooden%20sign%20with%20an%20exclamation%20mark%20beside%20a%20crumpled%20paper%20and%20a%20fresh%20notebook%20on%20a%20warm%20cream%20desk%2C%20soft%20thoughtful%20lighting%2C%20learning%20from%20mistakes%20editorial%20photography%20with%20warm%20amber%20and%20cream%20palette%2C%20clean%20encouraging%20composition&width=800&height=500&seq=article-12&orientation=landscape',
  },
  {
    id: '13',
    slug: 'allchinabuy-product-research',
    title: 'AllChinaBuy Product Research: Find Quality Items Fast',
    excerpt: 'Learn a proven process for researching products on AllChinaBuy, comparing options, checking materials, and finding the best quality for your budget.',
    category: 'Products',
    date: '2025-08-02',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20over%20neatly%20arranged%20small%20product%20swatches%20and%20fabric%20samples%20on%20a%20warm%20cream%20desk%2C%20bright%20focused%20lighting%2C%20product%20research%20editorial%20photography%20with%20warm%20beige%20and%20wood%20tones%2C%20detailed%20clean%20composition&width=800&height=500&seq=article-13&orientation=landscape',
  },
];